import { Component } from "solid-js";
import { Image, ImageProps } from "@unpic/solid";

export const Img: Component<ImageProps> = (props) => {
  return (
    <Image
      {...props}
    />
  );
};